<template>
	<div>
		<table-paginator
			:data="activities"
			@pagechange="$emit('pagechange', $event)"
		>
			<template v-for="activity in activities.data">
				<div class="row" :key="activity.id">
					<div class="col-12">
						<div
							class="d-flex p-3"
							style="border-left: 1px solid rgba(0, 0, 0, 0.1)"
						>
							<div style="margin-left:-1.4rem">
								<i
									class="fas fa-xs fa-circle text-success"
									style="outline:5px solid white;"
								></i>
							</div>
							<div class="d-flex flex-grow-1 justify-content-between">
								<div class="d-inline ml-2">
									<span class="ml-2">{{
										setActivityDescription(activity.action).description
									}}</span>
									<br />
									<small class="text-muted ml-2">{{
										activity.date | dateTimeBr
									}}</small>
								</div>
								<div class="ml-2 text-right">
									<button
										class="btn btn-sm btn-link text-info"
										@click="$emit('selectLog', activity)"
									>
										<i class="fas fa-plus" /> Mais Detalhes
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</template>
		</table-paginator>
	</div>
</template>

<script>
	import TablePaginator from '../../sections/TablePaginator'
	export default {
		components: { TablePaginator },

		computed: {
			activities() {
				return this.$store.state.activity.activities;
			},

			activityDescription() {
				return this.$store.state.activity.description;
			},
		},

		methods: {
			setActivityDescription(action) {
				return this.activityDescription.filter((activity) => (activity.action == action))[0]
			},
		},
	}
</script>

<style>

</style>